// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Produto } from './produto.model';
import { BaseNacional } from './base-nacional.model';

export class ProdutoFabricante extends BaseResourceModel {
    constructor(
        public id?: number,
        public fabricante_internacional?: boolean,
        public fabricante_base_nacional?: string,
        public registro_anvisa?: string,
        public nome_fantasia?: string,
        public material_base_nacional?: BaseNacional,
        public tipo?: 'B' | 'E' | 'S' | 'O',
        public produto?: Produto
    ) {
        super();
    }

    static converteJson(json: any): ProdutoFabricante {
        return Object.assign(new ProdutoFabricante(), json);
    }
}
